export default {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "icons.svg#instagram",
      toString: function () {
        return this.url;
      }
    }